module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-recommendation.7205a4f7.png";